module.exports = __webpack_public_path__ + "img/portfolio-details4.9e12fce0.png";